(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["b2b-moq-guard"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('B2bMoqGuard');
  if (!root || root.dataset.initialized === 'true') return;

  root.dataset.initialized = 'true';
  const minimum = Number(root.dataset.minimum || 500);

  function sendEvent(name, parameters = {}) {
    const payload = {
      event_category: 'B2B inquiry',
      page_location: window.location.href,
      ...parameters
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', name, payload);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...payload });
  }

  function showMessage(message, anchor) {
    root.replaceChildren();
    const title = document.createElement('strong');
    title.textContent = 'Minimum order quantity not met';
    const text = document.createElement('span');
    text.textContent = message;
    root.append(title, text);
    root.hidden = false;
    if (anchor?.parentElement && root.parentElement !== anchor.parentElement) {
      anchor.parentElement.insertBefore(root, anchor);
    }
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function hideMessage() {
    root.hidden = true;
    root.replaceChildren();
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.matches('.b2b-bulk-form')) {
      const quantity = Number(form.querySelector('[name="quantity"]')?.value || 0);
      if (quantity < minimum) {
        event.preventDefault();
        showMessage(`Enter at least ${minimum} pcs before adding this product.`, form);
      } else {
        hideMessage();
      }
    }

    if (form.matches('#B2bCartForm')) {
      const invalid = Array.from(form.querySelectorAll('input[name="updates[]"]')).find((input) => Number(input.value || 0) < minimum);
      if (invalid) {
        event.preventDefault();
        showMessage(`Each product in the bulk cart must total at least ${minimum} pcs.`, form);
        invalid.focus();
      } else {
        hideMessage();
      }
    }
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    const href = link.href || '';
    if (href.includes('wa.me/') || href.includes('whatsapp.com/')) {
      sendEvent('whatsapp_click', { link_url: href, link_text: link.textContent.trim() });
    } else if (href.startsWith('mailto:')) {
      sendEvent('email_click', { link_url: href, link_text: link.textContent.trim() });
    }
  });

  const contactPosted = new URLSearchParams(window.location.search).get('contact_posted') === 'true';
  const success = document.querySelector('.form-status-list .alert--success, [data-contact-success="true"]');
  const inquirySubmitted = window.location.pathname === '/pages/contact' && (contactPosted || Boolean(success));
  if (inquirySubmitted) {
    const key = `fojve-generate-lead:${window.location.pathname}:${window.location.search}`;
    if (sessionStorage.getItem(key) !== 'sent') {
      sendEvent('generate_lead', { form_name: 'wholesale_inquiry' });
      sessionStorage.setItem(key, 'sent');
    }
  }
})();
  } catch(e) { console.error(e); }
})();

})();
